import React from 'react';
import { Link } from 'react-router-dom';
import blogimage from '../../assets/images/blog_content_img.webp';
import TextContentHeader from './TextContentHeader';
import CallToAction from '../Misc/CallToAction';
import TextContentInner from './TextContentInner';
import Art from '../Misc/Art';
import illustration from '../../assets/images/art_2.png';

import { TextContentData } from '../../Data/TextContent';

function TextContent(props) {
    const contentData = props.contentData || TextContentData;
    const headerTitle = props.headerTitle || "About Us";
    const footerHeading = props.footerHeading || "Learn more about Dr. Mohammed Audu Rehab Centre";
    const primaryButtonText = props.primaryButtonText || "Learn More";
    const primaryButtonLink = props.primaryButtonLink || "/about";
    const secondaryButtonText = props.secondaryButtonText || "Our Programs";
    const secondaryButtonLink = props.secondaryButtonLink || "/programs";
    const hideSecondaryButton = props.hideSecondaryButton || false;
    const hideImage = props.hideImage || false;

    return (
        <>
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <TextContentHeader heading={headerTitle} />
                    <TextContentInner content={contentData} />
                    <div className="text-content-footer bg-black pt-0 pb-0">
                        <div className="container">
                            <div className="row align-items-lg-center">
                                <div className="col-md-6">
                                    <h3 className="heading heading-large light-1">
                                        {footerHeading}
                                    </h3>
                                </div>
                                <div className="col-md-6 d-md-inline-flex justify-content-md-end">
                                    <div className="button-wrapper d-flex flex-column align-items-end">
                                        <a className="button button-1 mb-3" href={primaryButtonLink}>
                                            {primaryButtonText}
                                        </a>
                                        {!hideSecondaryButton && (
                                            <Link className="button button-2" to={secondaryButtonLink}>
                                                {secondaryButtonText}
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Art art={illustration} type="2" />
                </div>

                {!hideImage && (
                    <div className="single-image ">
                        <img src={blogimage} alt="generic" />
                    </div>
                )}
            </div>
        </>
    );
}

export default TextContent;

// Duplicate for About page only
export function TextContentAboutPage() {
    const dummyData = [
        { content: 'Dr. Mohammed Audu Rehab Centre is a leading facility dedicated to the treatment and rehabilitation of individuals struggling with substance use disorders. We provide a safe, confidential, and supportive environment where healing can begin.' },
        { content: 'Our approach is rooted in evidence-based practices, combining medical detoxification with behavioral therapies and holistic support. We believe that recovery is possible for everyone, and we are committed to walking that path with our patients and their families.' }
    ];
    return (
        <>
            <div className="text-content">
                <div className="text-content-wrapper position-relative bg-black">
                    <TextContentInner content={dummyData} />
                    <Art art={illustration} type="2" />
                </div>
            </div>
        </>
    );
}

// New multi-section layout for About page
export function AboutMultiSection() {
    return (
        <div className="about-multisection">
            <div className="container">
                {/* Our Focus */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Our Focus</h3>
                    </div>
                    <div className="col-md-8">
                        <p className="paragraph dark-2 mb-0 about-multisection-description first-description">
                            Our primary focus is on comprehensive rehabilitation and recovery services:<br/>
                            • Medically Supervised Detoxification<br/>
                            • Inpatient Residential Rehabilitation<br/>
                            • Individual and Group Counseling<br/>
                            • Cognitive Behavioral Therapy (CBT)<br/>
                            • Family Therapy and Support Groups<br/>
                            • Relapse Prevention Planning<br/>
                            • Aftercare and Reintegration Support
                        </p>
                    </div>
                </div>
                {/* Why It Matters */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Why It Matters</h3>
                    </div>
                    <div className="col-md-8">
                        <p className="paragraph dark-2 mb-0 about-multisection-description">
                            Substance use disorders affect not just the individual, but entire families and communities. Without professional help, the cycle of addiction can be devastating. We provide the critical intervention needed to break this cycle, restoring health, relationships, and hope for a better future.
                        </p>
                    </div>
                </div>
                {/* Our Team */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Our Team</h3>
                    </div>
                    <div className="col-md-8">
                        <p className="paragraph dark-2 mb-0 about-multisection-description">
                            Our multidisciplinary team consists of experienced psychiatrists, medical doctors, clinical psychologists, nurses, and certified addiction counselors. We work collaboratively to ensure every patient receives personalized, compassionate, and expert care throughout their recovery journey.
                        </p>
                    </div>
                </div>
                {/* Join Us */}
                <div className="row align-items-center py-4">
                    <div className="col-md-4">
                        <h3 className="heading heading-medium dark-1 mb-0">Get Help</h3>
                    </div>
                    <div className="col-md-8 d-flex flex-column align-items-start">
                        <p className="paragraph dark-2 mb-3 about-multisection-description">
                            If you or a loved one is struggling with addiction, don't wait. Reach out to us today to learn more about our admission process and how we can help.
                        </p>
                        <a href="/contact" className="btn btn-main">Contact Us</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
